import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "grow strong" }
const _hoisted_4 = { class: "strong" }
const _hoisted_5 = {
  key: 0,
  class: "flex pb-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { key: "overview-details" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "strong pt-2" }, "Inkluderet i din pakke:", -1)
const _hoisted_13 = { class: "overview__coverage" }
const _hoisted_14 = {
  key: "updateSuggestKey",
  class: "highlights fill mb-4 mt-5"
}
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.model.choosePackage.selectedPackage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, "Pakke: " + _toDisplayString(_ctx.model.choosePackage.selectedPackage.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getMonthlyYearlyPrices(true)), 1)
          ]),
          (_ctx.cms.overviewShowYearlyPrice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", {
                  class: "flex",
                  innerHTML: _ctx.getMonthlyYearlyPrices(false)
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.overview.highlights, (highlight, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'high' + inx
            }, [
              _createElementVNode("div", {
                class: "flex",
                innerHTML: highlight
              }, null, 8, _hoisted_8)
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(['show-hide-details', { open: _ctx.showOrderDetails }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOrderDetails && _ctx.toggleOrderDetails(...args))),
            textContent: _toDisplayString((_ctx.showOrderDetails ? 'Skjul' : 'Vis') + ' detaljer')
          }, null, 10, _hoisted_9),
          _createVNode(_Transition, { name: "slide-vertical-no-delay" }, {
            default: _withCtx(() => [
              (_ctx.showOrderDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.overview.details, (detail, inx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'detail' + inx
                      }, [
                        _createElementVNode("div", { innerHTML: detail }, null, 8, _hoisted_11)
                      ]))
                    }), 128)),
                    _hoisted_12,
                    _createElementVNode("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverages, (coverage, inx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: 'covOver' + inx,
                          class: "coverage"
                        }, _toDisplayString(_ctx.cms.getCoverageName(coverage.name) || _ctx.cms.getCoverageName(coverage.title)), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.suggestText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", { innerHTML: _ctx.suggestText }, null, 8, _hoisted_16),
                  (_ctx.cms.plusCustomerPopover)
                    ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                        key: 0,
                        type: "icon",
                        class: "page-component__popover text-left",
                        buttonClass: "popover__icon popover__icon__questionmark",
                        innerData: _ctx.cms.plusCustomerPopover
                      }, null, 8, ["innerData"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "suggestText",
                    innerHTML: _ctx.suggestText1
                  }, null, 8, _hoisted_17)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.cms.showBasket)
        ? (_openBlock(), _createBlock(_component_ButtonTapComponent, {
            key: 0,
            class: "text-center btn-outline-secondary mt-3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoAddInsurances())),
            textContent: _toDisplayString(_ctx.cms.addProductsTxt),
            "data-gtm": _ctx.cms.dataGtm,
            "data-gtm-click-text": _ctx.cms.addProductsTxt
          }, null, 8, ["textContent", "data-gtm", "data-gtm-click-text"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass(['text-center', _ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep())),
        textContent: _toDisplayString(_ctx.card.linkText),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}